import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ReadMoreButtonStyle = styled(Button)(
  ({ theme, expand }: any) => `
  
  padding-left: 8px;
  margin-left: -8px;
  padding-right: 8px;
  font-size: 18px;
  color: ${theme.palette.primary.main};

  .MuiButton-endIcon {
    transform: ${expand ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: ${theme.transitions.create('transform', {
    duration: theme.transitions.duration.short,
  })};

    svg {
      font-size: 24px;
    }
  }
`,
);

export default ReadMoreButtonStyle;
